/* eslint-disable @typescript-eslint/no-namespace */
/**新增按钮/更新按钮-菜单管理抽屉页 */

/**显示/隐藏
 * @param {Hidden} Hidden 隐藏 0
 * @param {Display} Display 显示 1
 */
export enum IsHidden {
  Hidden,
  Display
}

/**是否保活菜单 keepalive
 * @param {YES} YES 是 1
 * @param {NO} NO 显示 1
 */
export enum IsKeepalive {
  NO,
  YES
}

/**是否新建标签页
 * @param {YES} YES 是 1
 * @param {NO} NO 否 0
 */
export enum IsBlank {
  NO,
  YES
}

/**权限菜单类型
 * @param {Directory} Directory 目录(一级菜单) 1
 * @param {Menu} Menu 菜单(二级菜单) 2
 * @param {ButtonAndList} ButtonAndList 按钮及列表 3
 */
export enum Type {
  Directory = 1,
  Menu = 2,
  ButtonAndList = 3
}

/**模式
 * @param {add} add 新增
 * @param {update} update 更新
 */
export enum Mode {
  add = 'add',
  update = 'update'
}

/**菜单抽屉 */
export namespace MenuDrawer {
  /**目录表单
   * @param {permission_name} permission_name 菜单名称
   * @param {module} module 所属模块
   * @param {route} route 路由path
   * @param {redirect} redirect Redirect
   * @param {sort} sort 排序
   * @param {parent_id} parent_id 父级菜单
   * @param {icon} icon 菜单Icon
   * @param {component} component 所属组件
   * @param {hidden} hidden 显示/隐藏
   * @param {keepalive} keepalive
   * @param {type} type 菜单类型
   * @param {is_blank} is_blank 当前菜单是否需要打开新标签页
   * @param {permission_mark} permission_mark 权限标识
   */
  export interface DirectoryRuleForm {
    permission_name: string
    module: string
    route: string
    redirect: string
    sort: number
    parent_id: number
    icon: string
    component: string
    hidden: IsHidden
    keepalive: IsKeepalive
    type: Type
    is_blank: IsBlank
    permission_mark: string
  }

  /**菜单表单
   * @param {permission_name} permission_name 菜单名称
   * @param {module} module 所属模块
   * @param {route} route 路由path
   * @param {redirect} redirect Redirect
   * @param {sort} sort 排序
   * @param {permission_mark} permission_mark 权限标识
   * @param {parent_id} parent_id 父级菜单
   * @param {icon} icon 菜单Icon
   * @param {component} component 所属组件
   * @param {hidden} hidden 显示/隐藏
   * @param {keepalive} keepalive
   * @param {type} type 菜单类型
   * @param {active_menu} active_menu 当前激活菜单
   * @param {is_blank} is_blank 当前菜单是否需要打开新标签页
   */
  export interface MenuRuleForm {
    permission_name: string
    module: string
    route: string
    redirect: string
    sort: number
    permission_mark: string
    parent_id: number
    icon: string
    component: string
    hidden: IsHidden
    keepalive: IsKeepalive
    type: Type
    active_menu: string
    is_blank: IsBlank
  }

  /**按钮及列表表单
   * @param {permission_name} permission_name 菜单名称
   * @param {sort} sort 排序
   * @param {parent_id} parent_id 父级菜单
   * @param {permission_mark} permission_mark 权限标识
   * @param {hidden} hidden 显示/隐藏
   * @param {keepalive} keepalive
   * @param {type} type 菜单类型
   */
  export interface ButtonRuleForm {
    permission_name: string
    sort: number
    parent_id: number
    permission_mark: string
    hidden: IsHidden
    keepalive: IsKeepalive
    type: Type
  }
}
